<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="(entry.employee_id ? entry.FirstName+' '+entry.LastName : entry.person_name) + ' - '+entry.covid_form_name+' [Custom Form] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/custom-forms`">
                            <i class="fa fa-file-text"></i> Custom Forms
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/custom-forms/entry/view/${entry.id}`">
                            {{ entry.covid_form_name }} -
                            <template v-if="entry.employee_id">
                                {{ entry.FirstName }} {{ entry.LastName }}
                            </template>
                            <template v-else>
                                {{ entry.person_name }}
                            </template>
                            - {{ entry.created_at | moment("MM/DD/YYYY") }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        Edit Status
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-7">

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Edit Entry Status:</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-warning mb-3">
                                You are about to change the status of this entry form from
                                <strong>{{ entry.entry_status }}</strong> to <strong>{{ entry.entry_status == 'Open' ? 'Closed' : 'Open' }}</strong>.
                                This will log the current timestamp and status change history.
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 text-lg-right text-muted">Current Status:</div>
                                <div class="col-lg-8">
                                    <label :class="'badge badge-'+(entry.entry_status == 'Open' ? 'danger' : 'success')+''">{{ entry.entry_status }}</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 text-lg-right text-muted">New Status:</div>
                                <div class="col-lg-8">
                                    <label :class="'badge badge-'+(entry.entry_status == 'Open' ? 'success' : 'danger')+''">
                                        {{ entry.entry_status == 'Open' ? 'Closed' : 'Open' }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button type="button" class="btn btn-sm btn-info" v-on:click="postStatus()">
                        Update Status
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                entry: {},
                personnel: [],
                covid_fields: [],
            }
        },

        computed: {
            canEdit(){
                if(this.$root.hasPermission('custom_forms.manage'))
                {
                    return true;
                }

                //Check Employee ID vs. Current User
                if(this.$store.state.user.EmployeeId !== null && this.$store.state.user.EmployeeId === this.entry.employee_id)
                {
                    return true;
                }

                return false;
            },
        },

        methods: {

            getEntry() {
                //Get the data
                this.$http
                    .get('/custom-forms/entry/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.entry = response.data.entry;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            postStatus() {
                //Saving
                this.saving = true;

                //Get the data
                this.$http
                    .post('/custom-forms/entry/status/' + this.id)
                    .then(response => {
                        //Push back to the view
                        this.$router.push('/custom-forms/entry/view/'+this.id);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Saving
                        this.saving = false;
                    });
            },

        },
        mounted() {
            //Get the Safety Meeting
            this.getEntry();
        }
    }
</script>
